import React, { useState } from 'react';
import PropTypes from 'prop-types';
import TagsInput from 'react-tagsinput';
import cn from 'classnames';
import ModalWindow from '../../common/Modal';
import Button from '../../common/Button';
import styles from './InviteRetailerModal.module.scss';
import { emailValidator } from '../../../utils/validators';

function InviteRetailerModal(props) {
  const { open = false } = props;

  let [tags, setTags] = useState([]);

  const validate = (tag) => {
    const { isError } = emailValidator(tag);
    return !isError;
  };

  const validateAll = () => {
    // If one of the tags doesn't validate, return false
    return !tags.some((tag) => !validate(tag));
  };

  const renderTag = (props) => {
    const { tag, key, disabled, className, onRemove, classNameRemove, getTagDisplayValue, ...other } = props;

    return (
      <span key={key} className={cn(className, validate(tag) ? '' : 'invalid')} {...other}>
        {getTagDisplayValue(tag)}
        {!disabled && <span className={classNameRemove} onClick={() => onRemove(key)} />}
      </span>
    );
  };

  const pasteSplit = (data) => {
    return data
      .replace(/[\r\n,;\t]/g, ' ')
      .split(' ')
      .map((d) => d.trim());
  };

  const onClose = () => {
    setTags([]);
    props.onClose();
  };

  const sendEmail = () => {
    props.sendEmail(tags);
    onClose();
  };

  return (
    <ModalWindow open={open} onClose={onClose} showCloseIcon={false}>
      <h2>Invite Boutiques</h2>

      <div className={styles.body}>
        <p>Boutiques you invite will receive an invitation email to register.</p>
        <p>Once registered you will be notified and you will need to approve them.</p>

        <TagsInput
          value={tags}
          renderTag={renderTag}
          inputProps={{ placeholder: 'Enter emails or copy paste a list' }}
          addOnBlur
          addKeys={[9, 13, 32, 186, 188]}
          pasteSplit={pasteSplit}
          onlyUnique
          addOnPaste
          onChange={setTags}
        />
      </div>
      <div className={styles.footer}>
        <Button color="white" text="CANCEL" onClick={onClose} />
        <Button text="INVITE" disabled={tags.length === 0 || !validateAll()} onClick={sendEmail} />
      </div>
    </ModalWindow>
  );
}

export default InviteRetailerModal;

InviteRetailerModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  sendEmail: PropTypes.func.isRequired,
};
